import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Projects.css';  // Import the CSS file

const Projects: React.FC = () => {

    const scrollToTop = () => {
        window.scrollTo(0, 0)
    }

    return (
        <div className="projects-container">
        <h1>Projects</h1>
        <div className="projects-grid" onClick={scrollToTop}>
            <Link to="/projects/JIPCAD">
                <div className="project-card">
                    <img src={require("./projects/JIPCAD/assets/jipcad-thumbnail.png")} alt="JIPCAD Thumbnail" />
                    <h3 className='project-title no-hover'>JIPCAD</h3>
                    <br />
                    <p className='project-date'>Aug 2020 - April 2024</p>
                </div>
            </Link>

            <Link to="/projects/ComputerGraphicsProjects">
                <div className="project-card">
                    <img src={require("./projects/ComputerGraphicsProjects/dragon_lens.png")} alt="Computer Graphics Projects Thumbnail" />
                    <h3 className='project-title'>Computer Graphics Projects</h3>
                    <br />
                    <p className='project-date'>Jan 2022 - May 2022</p>
                </div>
            </Link>

            <Link to="/projects/ComputerVisionProjects">
                <div className="project-card">
                    <img src={require("./projects/ComputerVisionProjects/starry_houses.png")} alt="Computer Vision and Computational Photography Projects Thumbnail" />
                    <h3 className='project-title'>Computer Vision & Computational Photography Projects</h3>
                    <br />
                    <p className='project-date'>Aug 2021 - Dec 2021</p>
                </div>
            </Link>

            <Link to="/projects/WhackAMole">
                <div className="project-card">
                    <img src={require("./projects/WhackAMole/assets/whack-a-mole-thumbnail.png")} alt="Whack-a-Mole Thumbnail" />
                    <h3 className='project-title'>Whack-a-Mole</h3>
                    <br />
                    <p className='project-date'>Aug 2022 - Nov 2023</p>
                </div>
            </Link>

            <Link to="/projects/MarimoMusic">
                <div className="project-card">
                    <img src={require("./projects/MarimoMusic/assets/marimo.jpg")} alt="Marimo Music Thumbnail" />
                    <h3 className='project-title'>marimo music</h3>
                    <br />
                    <p className='project-date'>Dec 2022</p>
                </div>
            </Link>

            <Link to="/projects/CheeseToastGame">
                <div className="project-card">
                    <img src={require("./projects/CheeseToastGame/cheese-toast-thumbnail.png")} alt="Cheese Toast Game Thumbnail" />
                    <h3 className='project-title'>Cheese Toast Maker Game</h3>
                    <br />
                    <p className='project-date'>Oct 2022</p>
                </div>
            </Link>

            <Link to="/projects/DoubleUseBags">
                <div className="project-card">
                    <img src={require("./projects/DoubleUseBags/double-use-bags.png")} alt="Double-Use Bags Thumbnail" />
                    <h3 className='project-title'>Double-Use Bags</h3>
                    <br />
                    <p className='project-date'>Sept 2022</p>
                </div>
            </Link>

            <Link to="/projects/CubeAquarium">
                <div className="project-card">
                    <img src={require("./projects/CubeAquarium/assets/shrimps0.png")} alt="Cube Aquarium Thumbnail" />
                    <h3 className='project-title'>Cube Aquarium</h3>
                    <br />
                    <p className='project-date'>March 2021 - May 2021</p>
                </div>
            </Link>

            <Link to="/projects/OldFriend">
                <div className="project-card">
                    <img src={require("./projects/OldFriend/assets/old-friend-thumbnail.png")} alt="Old Friend Thumbnail" />
                    <h3 className='project-title'>Old Friend</h3>
                    <br />
                    <p className='project-date'>Sept 2021 - Dec 2021</p>
                </div>
            </Link>

            <Link to="/projects/ToyBox">
                <div className="project-card">
                    <img src={require("./projects/ToyBox/assets/cornell-box-thumbnail.png")} alt="Toy Box Thumbnail" />
                    <h3 className='project-title'>Toy Box</h3>
                    <br />
                    <p className='project-date'>Feb 2021</p>
                </div>
            </Link>

            <Link to="/projects/Glowing">
                <div className="project-card">
                    <img src={require("./projects/Glowing/assets/glowing-thumbnail.png")} alt="Glowing Thumbnail" />
                    <h3 className='project-title'>Glowing</h3>
                    <br />
                    <p className='project-date'>Feb 2021 - March 2021</p>
                </div>
            </Link>

            <Link to="/projects/DanceDanceFish">
                <div className="project-card">
                    <img src={require("./projects/DanceDanceFish/assets/fish-thumbnail.png")} alt="Dance Dance Fish Thumbnail" />
                    <h3 className='project-title'>Dance Dance Fish</h3>
                    <br />
                    <p className='project-date'>Feb 2021</p>
                </div>
            </Link>

            <Link to="/projects/MrEgg">
                <div className="project-card">
                    <img src={require("./projects/MrEgg/mr-egg-site.png")} alt="Mr. Egg Thumbnail" />
                    <h3 className='project-title'>mr. egg and friends</h3>
                    <br />
                    <p className='project-date'>Nov 2019 - Dec 2019</p>
                </div>
            </Link>
            
        </div>
        </div>
    );
};

export default Projects;
